import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../core';
import { MotivoPerdaVendaConcorrente } from '../motivo-perda-venda-concorrente';

@Component({
    selector: 'sgt-motivo-perda-venda-concorrente-form',
    templateUrl: './motivo-perda-venda-concorrente-form.component.html',
    styleUrls: ['./motivo-perda-venda-concorrente-form.component.less']
})
export class MotivoPerdaVendaConcorrenteFormComponent {
    @Input() entity: MotivoPerdaVendaConcorrente;
    @ViewChild('form') form: NgForm;

    constructor(private messageService: MessageService) { }

    isValid() {
        if (this.form.invalid) {
            this.messageService.warning('Selecione corretamente todas as opções de concorrentes deste motivo', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
